/**
 * @generated SignedSource<<f17bcecf88a8c20f45668d5c0363655b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ApproveCollectionTransactionDetails_metadata$data = {
  readonly collections: ReadonlyArray<{
    readonly name: string;
    readonly " $fragmentSpreads": FragmentRefs<"CollectionMedia_collection">;
  }>;
  readonly " $fragmentType": "ApproveCollectionTransactionDetails_metadata";
};
export type ApproveCollectionTransactionDetails_metadata$key = {
  readonly " $data"?: ApproveCollectionTransactionDetails_metadata$data;
  readonly " $fragmentSpreads": FragmentRefs<"ApproveCollectionTransactionDetails_metadata">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ApproveCollectionTransactionDetails_metadata",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "CollectionType",
      "kind": "LinkedField",
      "name": "collections",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "CollectionMedia_collection"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "TransactionMetadataType",
  "abstractKey": null
};

(node as any).hash = "c29ab724c100a6baa989ba46817ec6d6";

export default node;
